import { Mesh, Quaternion, Vector3 } from 'three';

import { Point3D, Vector3D } from '@paragon/geometry-library';
import { Point3D as Point3DInterface, Segment3D } from '@paragon/three-shared';

import { updateMeshGeometry } from './updateMeshGeometry';

export function updateMatrixFromSegment(linkSegment: Segment3D, meshes: readonly Mesh[]) {
  const iPoint = new Vector3(linkSegment.start.x, linkSegment.start.y, linkSegment.start.z);
  const jPoint = new Vector3(linkSegment.end.x, linkSegment.end.y, linkSegment.end.z);

  const differenceVector = new Vector3().copy(jPoint).sub(iPoint);
  const center = new Vector3().copy(differenceVector).multiplyScalar(0.5);
  const direction = new Vector3().copy(differenceVector).normalize();

  const quaternion = new Quaternion().setFromUnitVectors(new Vector3(0, 1, 0), direction);
  const position = new Vector3().copy(iPoint).add(center);
  const scale = new Vector3(1, differenceVector.length(), 1);

  meshes.forEach((mesh) => updateMeshGeometry(mesh, position, scale, quaternion));
}

export function getTransformationPropsForSegment(basePointObject: Point3DInterface, endPointObject: Point3DInterface) {
  const basePoint = Point3D.fromObject(basePointObject);
  const endPoint = Point3D.fromObject(endPointObject);

  const vector = Vector3D.fromPointAndPoint(basePoint, endPoint);

  const position = basePoint.translate(vector.divideScalar(2));
  const quaternion = vector.direction
    ? new Quaternion().setFromUnitVectors(new Vector3(0, 1, 0), vector.direction)
    : undefined;

  return { position: position.toArray(), scale: [1, vector.magnitude, 1] as const, quaternion };
}
